import { Trans } from '@lingui/react/macro';

import type { PerioToothData } from '@/modules/insuranceExport/types';

import { formatState } from './helpers';

export const PlaqueMobilityBoneLossRow = () => (
  <div className="vai-w-40 vai-p-1 vai-font-semibold vai-bg-gray-50 vai-text-xs vai-border-r vai-border-gray-400">
    <Trans>Plaque/Mobility/Bone Loss</Trans>
  </div>
);

export const PlaqueMobilitySection = ({
  upperTeeth,
  lowerTeeth,
}: {
  upperTeeth: PerioToothData[];
  lowerTeeth: PerioToothData[];
}) => (
  <>
    <div className="vai-flex vai-border-b vai-border-gray-400 vai-h-8">
      <PlaqueMobilityBoneLossRow />
      <div className="vai-flex vai-flex-1">
        {upperTeeth.map((tooth, index) => (
          <div
            key={tooth.toothNumber}
            className={`vai-flex-1 vai-p-1 vai-text-center ${
              index < upperTeeth.length - 1
                ? 'vai-border-r vai-border-gray-400'
                : ''
            }`}
          >
            {formatState(tooth.plaque)} {tooth.mobility ?? '---'}{' '}
            {formatState(tooth.boneLoss)}
          </div>
        ))}
      </div>
    </div>
    <div className="vai-flex vai-border-b-2 vai-border-black vai-h-8">
      <PlaqueMobilityBoneLossRow />
      <div className="vai-flex vai-flex-1">
        {lowerTeeth.map((tooth, index) => (
          <div
            key={tooth.toothNumber}
            className={`vai-flex-1 vai-text-center ${
              index < lowerTeeth.length - 1
                ? 'vai-border-r vai-border-gray-400'
                : ''
            }`}
          >
            {formatState(tooth.plaque)} {tooth.mobility ?? '---'}{' '}
            {formatState(tooth.boneLoss)}
          </div>
        ))}
      </div>
    </div>
  </>
);
